/* eslint-disable max-lines */
import React from 'react';
import _ from 'lodash';
import { withTheme } from 'styled-components';
import PdfIcon from '@material-ui/icons/PictureAsPdf';
import { styled } from '@this/constants/themes';
import A from '@this/components/shared/atoms/a';
import TranslateIgnoreText from '@this/components/shared/text/translate_ignore_text';
import { media } from '@this/components/shared/atoms/media';
import type Trip2 from '@this/domain/trip/trip2';
import MarketLogHelper from '@this/domain/market_log/market_log_helper';
import type Department from '@this/domain/department/department';
import type Project from '@this/domain/project/project';
import { toDomesticTel } from '@this/src/util';
import type TransportElementAttachFile from '@this/domain/transport_element_attach_file';
import Notification from '../../../notification';
import ReceiptCardHead from './trip_receipt_card_head';
import moment from '../../../lib/moment';

interface Props {
  trip: any;
  trip2?: Trip2;
  user: any;
  departments: Department[];
  projects: Project[];
  serviceId: number;
  fetchTrips: () => void;
  theme: Theme;
  apiTotalPrice: number;
  invoiceOrderItems: any[];
}

interface Translatedline {
  label: string;
  value: string;
  translate: boolean;
}

interface Theme {
  themeClass: string;
  serviceName: string;
}

class TripReceiptCard extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  showDisableNotification = () => {
    Notification.error('この海外航空券は発券期限が過ぎています。\n手配オペレーターまでチャットでご連絡ください。');
  };

  endTime(): Date | null {
    const { trip } = this.props;
    const endTime = utils.dig(trip, 'endTime') || trip.order.endDate() || trip.return_time;
    return endTime;
  }

  parseApproveItemJson = (item: string) => {
    return JSON.parse(item);
  };

  content() {
    const { trip, trip2, theme /* handleHotelCancelClick */, user, serviceId, invoiceOrderItems } = this.props;
    const sortTransportElementAttachFiles = (
      files: TransportElementAttachFile[],
      travelerInformations: any[],
      userId: number
    ): TransportElementAttachFile[] => {
      return files.slice().sort((a, b) => {
        const aUserIdMatch = travelerInformations.some(
          traveler => traveler.id === a.travelerInformationId && traveler.userId === userId
        );
        const bUserIdMatch = travelerInformations.some(
          traveler => traveler.id === b.travelerInformationId && traveler.userId === userId
        );
        // user_id が一致するファイルを先頭に、それ以外はid順
        if (aUserIdMatch && !bUserIdMatch) return -1;
        if (!aUserIdMatch && bUserIdMatch) return 1;
        return a.id - b.id;
      });
    };

    return (
      <>
        {invoiceOrderItems.map((orderItemJson: any, i: number) => {
          // trip.order.orderItems と同じように使えるようにorderItemオブジェクトを作成
          const orderItem = trip.order.orderItems.find((item: any) => item.id === orderItemJson.id) || {
            id: orderItemJson.id,
            orderItemCategory: orderItemJson.type,
            totalPriceWithAll: () => orderItemJson.price,
            elements: [],
            isFollowingElement: () => false,
            isPrecedingElement: () => false,
            travelerShinkansenTypes: () => [],
            travelerAirlineTypes: () => [],
            travelerInformations: [],
            price: {
              totalPrice: () => orderItemJson.price
            }
          };

          return (
            <StyledMainContent key={`${i}`}>
              <StyledMainContentBody>
                {orderItem.orderItemCategory === 'arrangement_request' ? (
                  <StyledMainBlock>
                    <StyledBlockTitle>リクエストフォーム利用料</StyledBlockTitle>
                    <StyledBlockContent>
                      <span data-wovn-ignore>{utils.digits(orderItem.totalPriceWithAll())}</span>
                      <span>円</span>
                    </StyledBlockContent>
                  </StyledMainBlock>
                ) : (
                  <>
                    {orderItem.elements.map((element: any, j: number) => (
                      <StyledMainBlock key={`${i}_${j}`}>
                        {!orderItem.isFollowingElement(element) && (
                          <StyledBlockTitle>{element.title()}</StyledBlockTitle>
                        )}
                        <StyledBlockContent>
                          {element.type === 'hotel' &&
                            (element.isCanceled(orderItem.orderItemCategory)
                              ? element.name && (
                                  <>
                                    <StyledCanceledBlockTextL data-wovn-ignore>
                                      {element.name}
                                    </StyledCanceledBlockTextL>
                                    <StyledCancelMessage>(キャンセル済み)</StyledCancelMessage>
                                  </>
                                )
                              : element.name && (
                                  <StyledBlockTextL data-wovn-ignore>{element.name}</StyledBlockTextL>
                                ))}
                          {element.type === 'transport' && (element.name || '')}
                          <StyledBlockTextM>
                            <TranslateIgnoreText text={element.summary()} />
                          </StyledBlockTextM>
                          <StyledBlockTextM>
                            {element.type === 'hotel' ? (
                              <>
                                <p>
                                  返金：
                                  {element.refundable === 'true' ? ( // 文字列で入ってくる・・・
                                    <span>
                                      可
                                      {/*
                                      {trip.isOngoing &&
                                        trip.currentApprovalStatus() !== 0 &&
                                        element.isCancelable(orderItem.orderItemCategory) && (
                                          <A onClick={e => handleHotelCancelClick(element.id, e)}>
                                            （キャンセルする） → マイナビの都合で一旦ペンディング。仕様策定後再度対応する
                                            </A>
                                        )}
                                      */}
                                    </span>
                                  ) : element.refundable === 'false' ? (
                                    <span>不可</span>
                                  ) : (
                                    <span>お問い合わせください</span>
                                  )}
                                </p>
                                {element.structuredHotelTypeDetail().map((l: Translatedline, k: number) => {
                                  return l.translate ? (
                                    <StyledBlockTextM key={`t_${k}`}>
                                      <span key={`hotel_label_t_${k}`}>{l.label}</span>
                                      <span key={`hotel_value_t_${k}`}>{l.value}</span>
                                    </StyledBlockTextM>
                                  ) : (
                                    <StyledBlockTextM key={`nt_${k}`}>
                                      <span key={`hotel_label_nt_${k}`}>{l.label}</span>
                                      <span data-wovn-ignore key={`hotel_value_nt_${k}`}>
                                        {l.value}
                                      </span>
                                    </StyledBlockTextM>
                                  );
                                })}
                                {element.detailPath && (
                                  <StyledBlockTextM>
                                    <span>宿泊詳細情報：</span>
                                    <span>
                                      <a href={element.detailPath} target="_blank" rel="noopener noreferrer">
                                        詳細はコチラ
                                      </a>
                                    </span>
                                  </StyledBlockTextM>
                                )}
                                <p>
                                  住所:{' '}
                                  <a
                                    data-wovn-ignore
                                    href={element.hotelMapAddressLink()}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {element.address ? element.address : '所在地を確認'}
                                  </a>
                                </p>
                                <p>
                                  {element.tel && (
                                    <>
                                      <span>電話番号：</span>
                                      <span data-wovn-ignore>{toDomesticTel(element.tel)}</span>
                                    </>
                                  )}
                                </p>
                                <StyledRoom>
                                  {element.structuredRoomTypeDetail().map((l: Translatedline, k: number) => {
                                    return l.translate ? (
                                      <StyledBlockTextM key={`t_${k}`}>
                                        <span>{l.label}</span>
                                        <span>{l.value}</span>
                                      </StyledBlockTextM>
                                    ) : (
                                      <StyledBlockTextM key={`nt_${k}`}>
                                        <span>{l.label}</span>
                                        <span data-wovn-ignore>{l.value}</span>
                                      </StyledBlockTextM>
                                    );
                                  })}
                                </StyledRoom>
                                {element.hotelReservationNumber &&
                                  orderItem.orderItemCategory === 'rakuten_package' && (
                                    <>
                                      <span>ホテル予約番号：</span>
                                      <span data-wovn-ignore>{element.hotelReservationNumber}</span>
                                    </>
                                  )}
                              </>
                            ) : (
                              !orderItem.isPrecedingElement(element) && (
                                <>
                                  {element.structuredDetail(orderItem).map((l: Translatedline, k: number) => {
                                    return l.translate ? (
                                      <StyledBlockTextM key={`t_${k}`}>
                                        <span>{l.label}</span>
                                        <span>{l.value}</span>
                                      </StyledBlockTextM>
                                    ) : (
                                      <StyledBlockTextM key={`nt_${k}`}>
                                        <span>{l.label}</span>
                                        <span data-wovn-ignore>{l.value}</span>
                                      </StyledBlockTextM>
                                    );
                                  })}
                                  <StyledMainSlimTable>
                                    <tbody>
                                      {orderItem.travelerShinkansenTypes() &&
                                        orderItem.travelerShinkansenTypes().map((tst: string, i: number) => (
                                          <tr key={i}>
                                            {orderItem.travelerShinkansenTypes().length > 1 ? (
                                              <StyledMainTdData>{`${i + 1}人目`}</StyledMainTdData>
                                            ) : (
                                              <StyledMainTdData>出張者</StyledMainTdData>
                                            )}
                                            <StyledMainTd>
                                              <TranslateIgnoreText text={tst} />
                                            </StyledMainTd>
                                          </tr>
                                        ))}
                                      {orderItem.travelerAirlineTypes() &&
                                        orderItem.travelerAirlineTypes().map((tat: string, i: number) => (
                                          <tr key={i}>
                                            {orderItem.travelerAirlineTypes().length > 1 ? (
                                              <StyledMainTdData>{`${i + 1}人目`}</StyledMainTdData>
                                            ) : (
                                              <StyledMainTdData>出張者</StyledMainTdData>
                                            )}
                                            <StyledMainTd>
                                              <TranslateIgnoreText text={tat} />
                                            </StyledMainTd>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </StyledMainSlimTable>
                                  {element.detailPath && (
                                    <StyledBlockTextM>
                                      <span>宿泊詳細情報：</span>
                                      <span>
                                        <a href={element.detailPath} target="_blank" rel="noreferrer noopener">
                                          詳細はコチラ
                                        </a>
                                      </span>
                                    </StyledBlockTextM>
                                  )}
                                </>
                              )
                            )}
                            {!orderItem.isPrecedingElement(element) && (
                              <>
                                <StyledSpace />
                                {element.type === 'transport' && (
                                  <>
                                    {theme.themeClass === 'tabikobo' &&
                                      orderItem.price.flightPriceChangeDetail && (
                                        <p>{orderItem.price.flightPriceChangeDetail}</p>
                                      )}
                                    {element.isRawTicketingExpired(orderItem) && (
                                      <p>
                                        発券期限：
                                        <StyledDeadline>{element.rawTicketingExpiredAt(orderItem)}</StyledDeadline>
                                      </p>
                                    )}
                                  </>
                                )}
                                {MarketLogHelper.isElementMarketLogLinkAvailable(
                                  element,
                                  theme.serviceName,
                                  trip2
                                ) && (
                                  <A
                                    href={MarketLogHelper.elementMarketLogPath(element, trip.id)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    マーケットログを確認
                                    <img
                                      className="organization-trips-detail__detail-panel__item-block__market-log-link-confirm"
                                      src="/images/external_link_icon.png"
                                      alt="link"
                                    />
                                  </A>
                                )}
                              </>
                            )}
                          </StyledBlockTextM>
                          <StyledAttachFilesContainer>
                            {sortTransportElementAttachFiles(
                              element.transportElementAttachFiles || [],
                              orderItem.travelerInformations,
                              user.id
                            ).map((transportElementAttachFile: TransportElementAttachFile) => {
                              const attachFileTraveler = orderItem.travelerInformations.find(
                                (traveler: any) => traveler.id === transportElementAttachFile.travelerInformationId
                              );
                              return (
                                <div key={transportElementAttachFile.id} style={{ flex: '0 1 auto' }}>
                                  <StyledBlockTextM style={{ display: 'flex' }}>
                                    <PdfIcon style={{ color: '#a72c09', marginRight: '2px' }} />
                                    <A
                                      href={`/trips/${transportElementAttachFile.tripId}/transport_element_attach_files/${transportElementAttachFile.id}.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ display: 'flex', alignItems: 'center' }}
                                    >
                                      {transportElementAttachFile.uploadFileName}
                                    </A>
                                  </StyledBlockTextM>
                                  <StyledAttachFileTraveler>
                                    {attachFileTraveler && ` ${attachFileTraveler.name} 様`}
                                  </StyledAttachFileTraveler>
                                </div>
                              );
                            })}
                          </StyledAttachFilesContainer>
                          {utils.isAiTravel(serviceId) &&
                            (orderItem.ticketingMethod === 'qr_east' ||
                              orderItem.ticketingMethod === 'qr_west') && (
                              <StyledBlockTextM>
                                {orderItem.ticketingMethod === 'qr_east' ? (
                                  <A
                                    href="https://aitravel.my.salesforce.com/sfc/p/#7F000002CrgE/a/TL000001LMUo/pwjAtO_q8Pn6wBGvZenzhYrsVGKLyVqbayim29VPb_Q"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    ※JRチケット発券マニュアル
                                  </A>
                                ) : (
                                  <A
                                    href="https://aitravel.my.salesforce.com/sfc/p/#7F000002CrgE/a/TL000001LNIn/LHHz9yTUs8Oa9bz5k7ywE7EiAhoBqjuNDUJitIYaq80"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    ※JRチケット発券マニュアル
                                  </A>
                                )}
                              </StyledBlockTextM>
                            )}
                        </StyledBlockContent>
                      </StyledMainBlock>
                    ))}
                    {orderItem.eTickets?.length > 0 &&
                      orderItem.eTickets.map((ticket: any, j: number) => (
                        <p key={j}>
                          <a href={ticket.link} target="_blank" rel="noopener noreferrer">
                            e-ticketを表示
                            <img
                              className="organization-trips-detail__detail-panel__item-block__market-log-link-confirm"
                              src="/images/external_link_icon.png"
                              alt="link"
                            />
                          </a>
                        </p>
                      ))}
                    {orderItem.price && (
                      <StyledMainBlock>
                        <span data-wovn-ignore>{utils.digits(orderItem.price.totalPrice())}</span>
                        <span>円</span>
                      </StyledMainBlock>
                    )}
                  </>
                )}
              </StyledMainContentBody>
            </StyledMainContent>
          );
        })}
      </>
    );
  }

  getChargingDepartmentNames = () => {
    const { trip } = this.props;

    if (trip.charging_departments && trip.charging_departments.length > 0) {
      return trip.charging_departments.map((data: any) => (
        <div key={data.id} data-wovn-ignore>
          {data.code}:{data.name}
        </div>
      ));
    }

    if (trip?.order?.order_items && trip.order.order_items.length > 0) {
      return (
        trip.order.order_items &&
        trip.order.order_items.map((orderItem: any, i: number) => {
          if (orderItem.order_item_mappings.some((mapping: any) => mapping.charging_department_id == null)) {
            return <div />;
          }

          return (
            <div key={`order-item-${orderItem.id}`}>
              <div data-wovn-ignore>
                {i + 1}. {orderItem?.order_item_category_text}
              </div>
              <div style={{ marginLeft: '10px' }}>
                {orderItem.order_item_mappings.map((mapping: any) => (
                  <div key={`mapping-${mapping.charging_department_id}`} data-wovn-ignore>
                    {mapping.display_charging_department}
                  </div>
                ))}
              </div>
            </div>
          );
        })
      );
    }

    return null;
  };

  getProjectNames = () => {
    const { trip } = this.props;

    if (trip.projects && trip.projects.list.length > 0) {
      return trip.projects.list.map((data: any) => (
        <div key={data.id} data-wovn-ignore>
          {data.code}:{data.name}
        </div>
      ));
    }

    if (trip.order && trip.order.order_items && trip.order.order_items.length > 0) {
      return (
        trip.order.order_items &&
        trip.order.order_items.map((orderItem: any, i: number) => {
          if (orderItem.order_item_mappings.some((mapping: any) => mapping.project_id == null)) {
            return <div />;
          }

          return (
            <div key={`order-item-${orderItem.id}`}>
              <div data-wovn-ignore>
                {i + 1}. {orderItem?.order_item_category_text}
              </div>
              <div style={{ marginLeft: '10px' }}>
                {orderItem.order_item_mappings.map((mapping: any) => (
                  <div key={`mapping-${mapping.project_id}`} data-wovn-ignore>
                    {mapping.display_project}
                  </div>
                ))}
              </div>
            </div>
          );
        })
      );
    }

    return null;
  };

  render() {
    const { trip, departments, projects, serviceId } = this.props;
    const travelerNames: string[] = trip.travelerNames();

    return (
      <StyledSimpleCardWrap>
        <StyledSimpleCard key={trip.id}>
          <StyledCardHead>
            <ReceiptCardHead trip={trip} serviceId={serviceId} apiTotalPrice={this.props.apiTotalPrice} />
          </StyledCardHead>
          <StyledSimpleCardBody>
            <StyledCardMain>
              <StyledCardContent>
                {this.content()}
                {trip.in_advance_approval && (
                  <>
                    {trip.shinkansen_deadline && trip.approvalStatus(trip.in_advance_approval.length - 1) === 0 && (
                      <StyledMainInfo>
                        <StyledRed>
                          <span>新幹線・特急チケットは、</span>
                          <span data-wovn-ignore>{trip.shinkansen_deadline}</span>
                          <span>が承認期限です。</span>
                        </StyledRed>
                      </StyledMainInfo>
                    )}
                  </>
                )}
              </StyledCardContent>
            </StyledCardMain>
            <StyledCardSub>
              <StyledSubBlock>
                <StyledSubTitle>申請情報</StyledSubTitle>
                <StyledSubTable>
                  <tbody>
                    <tr>
                      <StyledSubTdData>出張期間</StyledSubTdData>
                      <StyledSubTdColon>：</StyledSubTdColon>
                      <StyledSubTd>
                        <TranslateIgnoreText text={trip.dateRange()} />
                      </StyledSubTd>
                    </tr>
                    {trip.in_advance_approval ? (
                      <tr>
                        <StyledSubTdData>申請者</StyledSubTdData>
                        <StyledSubTdColon>：</StyledSubTdColon>
                        <StyledSubTd>
                          <TranslateIgnoreText text={trip.user.name} />
                        </StyledSubTd>
                      </tr>
                    ) : (
                      <tr />
                    )}
                    {travelerNames &&
                      travelerNames.map((tn, i) => (
                        <tr key={i}>
                          {travelerNames.length > 1 ? (
                            <StyledSubTdData>{`出張者${i + 1}`}</StyledSubTdData>
                          ) : (
                            <StyledSubTdData>出張者</StyledSubTdData>
                          )}
                          <StyledSubTdColon>：</StyledSubTdColon>
                          <StyledSubTd>
                            <TranslateIgnoreText text={tn} />
                          </StyledSubTd>
                        </tr>
                      ))}
                    <tr>
                      <StyledSubTdData>訪問先</StyledSubTdData>
                      <StyledSubTdColon>：</StyledSubTdColon>
                      <StyledSubTd>
                        <TranslateIgnoreText text={trip?.final_destination || ''} />
                      </StyledSubTd>
                    </tr>
                    <tr>
                      <StyledSubTdData>目的</StyledSubTdData>
                      <StyledSubTdColon>：</StyledSubTdColon>
                      <StyledSubTd>
                        <TranslateIgnoreText text={trip?.purpose || ''} />
                      </StyledSubTd>
                    </tr>
                    <tr>
                      <StyledSubTdData>社内管理番号</StyledSubTdData>
                      <StyledSubTdColon>：</StyledSubTdColon>
                      <StyledSubTd>
                        <TranslateIgnoreText text={trip.internal_number || ''} />
                      </StyledSubTd>
                    </tr>
                    {trip.trip_approve_item &&
                      this.parseApproveItemJson(trip.trip_approve_item.json).map((item: any) => {
                        if (item.dataType === 'label') {
                          return <></>;
                        }
                        return (
                          <tr key={item.id}>
                            <StyledSubTdData>
                              <span data-wovn-ignore>{item.userDisplayName}</span>
                            </StyledSubTdData>
                            <StyledSubTdColon>：</StyledSubTdColon>
                            <StyledSubTd>
                              {item.dataType !== 'calendar' && (
                                <>
                                  {item.valueCode ? (
                                    <span data-wovn-ignore>
                                      {item.valueCode}：{item.value}
                                    </span>
                                  ) : (
                                    <span data-wovn-ignore>{item.value}</span>
                                  )}
                                </>
                              )}
                              {item.dataType === 'calendar' && (
                                <span data-wovn-ignore>
                                  {item.value ? moment(item.value).format('MM月DD日') : ''}
                                </span>
                              )}
                            </StyledSubTd>
                          </tr>
                        );
                      })}
                    {departments && departments.length > 0 ? (
                      <tr>
                        <StyledSubTdData>費用負担部署</StyledSubTdData>
                        <StyledSubTdColon>：</StyledSubTdColon>
                        <StyledSubTd data-wovn-ignore>{this.getChargingDepartmentNames()}</StyledSubTd>
                      </tr>
                    ) : (
                      <tr />
                    )}
                    {projects && projects.length > 0 ? (
                      <tr>
                        <StyledSubTdData>プロジェクトコード</StyledSubTdData>
                        <StyledSubTdColon>：</StyledSubTdColon>
                        <StyledSubTd data-wovn-ignore>{this.getProjectNames()}</StyledSubTd>
                      </tr>
                    ) : (
                      <tr />
                    )}
                  </tbody>
                </StyledSubTable>
              </StyledSubBlock>
            </StyledCardSub>
          </StyledSimpleCardBody>
        </StyledSimpleCard>
      </StyledSimpleCardWrap>
    );
  }
}

const StyledSimpleCardWrap = styled.div`
  overflow: hidden;
  margin-bottom: 25px;
  border-radius: 5px;
`;

const StyledSimpleCard = styled.div`
  background: #fff;
  transition: margin ease-in 0.3s;
`;

const StyledSimpleCardBody = styled.div`
  display: flex;
  background: #fff;
  border-radius: 5px;
  font-size: 12px;

  ${media.sp`
    display: block;
  `}
`;

const StyledCardMain = styled.div`
  flex-grow: 1;
`;

const StyledCardHead = styled.div`
  width: 100%;
  display: flex;
  padding: 10px 20px;
  border-bottom: solid 1px ${props => props.theme.grayBorderColor};
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
  }
`;

const StyledCardContent = styled.div`
  padding: 15px;
  background-color: #f7f7f7;
`;

const StyledMainTable = styled.table`
  width: auto;
  margin: 0 0 20px;
  border: none;
  vertical-align: top;
`;

const StyledMainSlimTable = styled(StyledMainTable)`
  margin: 0 !important;
`;

const StyledMainTd = styled.td`
  padding: 5px 0;
  border: none;
  vertical-align: top;
  color: ${props => props.theme.grayTextColor}
  font-weight: bold;

  ${media.sp`
    padding: 3px 0;
  `}
`;

const StyledMainTdData = styled(StyledMainTd)`
  width: 60px;
  color: ${props => props.theme.disabledColor};
`;

const StyledMainContent = styled.div`
  border: solid 1px ${props => props.theme.grayBorderColor};
  background-color: #ffffff;
  margin-bottom: 14px;
  position: relative;
`;

const StyledMainContentBody = styled.div`
  padding: 12px;
`;

const StyledMainBlock = styled.div``;

const StyledBlockTitle = styled.p`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.6;
  margin-bottom: 10px;

  ${media.sp`
    font-size: 12px;
  `}
`;

const StyledBlockContent = styled.div`
  line-height: 1.8;
`;

const StyledBlockTextL = styled.div`
  font-size: 14px;
  font-weight: bold;
  ${media.sp`
    font-size: 12px;
  `}
`;

const StyledCanceledBlockTextL = styled.div`
  font-size: 14px;
  font-weight: bold;
  text-decoration: line-through;
  ${media.sp`
    font-size: 12px;
  `}
`;

const StyledCancelMessage = styled.div`
  color: red;
`;

const StyledBlockTextM = styled.div``;

const StyledSpace = styled.div`
  margin-bottom: 10px;
`;

const StyledRoom = styled.div`
  margin-top: 20px;
`;

const StyledMainInfo = styled.div`
  padding-bottom: 20px;
`;

const StyledRed = styled.p`
  color: ${props => props.theme.redColor};
`;

const StyledDeadline = styled.span`
  color: ${props => props.theme.redColor};
`;

const StyledCardSub = styled.div`
  min-width: 300px;
  width: 300px;
  padding: 15px 20px;
  background: #ffffff;
  border-top: solid 1px ${props => props.theme.grayBorderColor};

  ${media.sp`
    min-width: 100%;
    width: 100%;
  `}
`;

const StyledSubBlock = styled.div`
  margin-bottom: 20px;
`;

const StyledSubTitle = styled.p`
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: bold;

  ${media.sp`
    font-size: 12px;
  `}
`;

const StyledSubTable = styled.table`
  width: auto;
  margin: 0;
  border: none;
  font-size: 11px;
  vertical-align: top;

  ${media.sp`
    font-size: 10px;
  `}
`;

const StyledSubTd = styled.td`
  padding: 4px 0;
  border: none;
  vertical-align: top;

  ${media.sp`
    padding: 3px 0;
  `}
`;

const StyledSubTdData = styled(StyledSubTd)`
  width: 68px;
`;

const StyledSubTdColon = styled(StyledSubTd)`
  width: 15px;
`;

const StyledAttachFilesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 5px;
  justify-content: flex-start;
  align-items: flex-start;
`;

const StyledAttachFileTraveler = styled.p`
  font-size: 10px;
  margin-left: 5px;
`;

export default withTheme(TripReceiptCard);
